<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="500px">
    <v-card class="pb-1">
      <v-card-title class="px-3 pt-3" v-if="title">
        <h4 class="font-weight-bold">{{title}}</h4>
      </v-card-title>
      <v-divider class="my-1 mx-3" v-if="title"></v-divider>
      <v-card-text class="text-center">
        <h4 class="ma-3" style="white-space:pre-wrap;" v-html="content"></h4>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn class="border-1 registration" flat @click.native="confirmAction">{{confirmButtonText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'simple_alert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    confirmButtonText: {
      type: String,
      default: '확인'
    },
    confirmAction: {
      type: Function
    }
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/simple_alert.vue